import {Component, Input, OnInit} from '@angular/core';
import {DEF_INPUT_SIZE} from "../../enums/enums";

@Component({
  selector: 'nv-input-static',
  templateUrl: './nv-input-static.component.html',
  styles: []
})
export class NvInputStaticComponent implements OnInit {
  _label:string;
  _col:number;

  @Input() value: string = "";
  @Input() help:string;
  @Input() hide_label:boolean = false;
  @Input() multi:boolean = false;


  @Input() set label(v:string) { this._label = v; }
  @Input() set size(v:number) { this._col = v; }

  get label():string { return this._label || ""; }
  get size():number { return this._col || DEF_INPUT_SIZE; }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-input/nv-input-static.component.ts